import { AxiosPromise } from 'axios';
import { IEventRecordParams } from '../models/paymentsEvents.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/payments/events';

export const getEventRecords = (params: IEventRecordParams): AxiosPromise => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/list?${qsParams}`);
}

export const getEventRefunds = (params: IEventRecordParams): AxiosPromise => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/refund/list?${qsParams}`);
}
